module.exports = __webpack_public_path__ + "img/clock2-01.21a5c4f0.png";